import { z } from 'zod';

/**
 * A legal document version's place in its lifecycle (`00-full-system.md` §4).
 *
 * `draft → published → superseded`, and never backwards. Only a **draft** is
 * editable: N16 makes a published version immutable, because a consent record
 * points at it and text that can change after acceptance records nothing at
 * all. `superseded` is what a published version becomes when a newer one is
 * published — still readable forever, because members consented to it.
 */
export const LEGAL_VERSION_STATUSES = ['draft', 'published', 'superseded'] as const;

export const LegalVersionStatusSchema = z.enum(LEGAL_VERSION_STATUSES);

export type LegalVersionStatus = (typeof LEGAL_VERSION_STATUSES)[number];

/**
 * Whether a version's content may still be edited.
 *
 * Exported rather than inlined as `status === 'draft'` so the api's
 * immutability guard, the admin editor's read-only state and any future caller
 * answer the question the same way (U3).
 */
export function isEditableVersionStatus(status: LegalVersionStatus): boolean {
  return status === 'draft';
}
